export default {
	win: {
		sm: 576,
		md: 768,
		lg: 1200,
		xl: 1600
	}
}